export const C = {
  coal: "#0c0a09",
  bark: "#1c1612",
  rust: "#3d2a1f",
  dirt: "#6b4a32",
  grass: "#4a5a38",
  dry: "#8a7a5c",
  bone: "#c4a574",
  lantern: "#e8d5a3",
  blood: "#8b2e1f",
  cinder: "#3d5c4a",
  night: "#1a2330",
  storm: "#4a6a8a",
  magenta: "#ff00ff",
};

export const TILE_FALLBACK: Record<number, string> = {
  1: C.grass,
  2: C.dirt,
  3: "#7a5a3a",
  4: "#4a3020",
  5: "#5a7a38",
  6: "#1a3040",
  7: "#243018",
  8: "#3a2a18",
  9: "#2a221c",
  10: "#4a3828",
  11: "#6a4a28",
  12: "#5a5248",
  13: "#3a322c",
  14: "#2a1814",
  15: "#3a4a28",
  16: "#6a5840",
  17: "#3a2418",
  18: "#1c1a18",
  19: "#3d5c4a",
  20: "#2a3a28",
  21: "#1a3020",
};

export function hexRgb(hex: string): [number, number, number] {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
